import {
  RadioInputProps,
  RadioInputTemplateProps,
  RadioInputDefaultTemplate,
  RadioInputContentTemplate,
  RadioInputPaymentTemplate,
  useRadioInputEffect,
} from '../../..';

export const RadioInputElement = (props: RadioInputProps) => {
  const [state, handlers] = useRadioInputEffect(props);

  const templateProps: RadioInputTemplateProps = {
    id: props.id,
    name: props.name,
    inlay: props.inlay,
    children: props.children,
    ...state,
    ...handlers,
  };

  let template;
  switch (props.template) {
    case 'radioInputPayment':
      template = RadioInputPaymentTemplate(templateProps);
      break;
    case 'radioInputContent':
      template = RadioInputContentTemplate(templateProps);
      break;
    case 'radioInputDefault':
    default:
      template = RadioInputDefaultTemplate(templateProps);
      break;
  }

  return template;
};
